import { createSlice } from "@reduxjs/toolkit";
import {
  getBandAnalyticsBuilder,
  getBandProductAnalyticsBuilder,
  getBandProductsBuilder,
  getBandOrdersBuilder,
  getBandMonthlyRevenuesBuilder,
  getMonthlyBandRevenuesByPeriodBuilder,
} from "./builder";

const initialState = {
  analytics: {
    data: null,
    loading: false,
    error: null,
  },
  productAnalytics: {
    data: null,
    loading: false,
    error: null,
  },
  products: {
    data: [],
    loading: false,
    error: null,
  },
  orders: {
    data: [],
    total: 0,
    page: 0,
    perPage: 10,
    loading: false,
    error: null,
  },
  monthlyRevenues: {
    data: [],
    loading: false,
    error: null,
  },
  monthlyBandRevenuesByPeriod: {
    data: [],
    loading: false,
    error: null,
  },
};

export const bandDashboardSlice = createSlice({
  name: "bandDashboard",
  initialState,
  reducers: {
    clearAnalytics: (state) => {
      state.analytics.data = null;
      state.analytics.error = null;
    },
    clearProductAnalytics: (state) => {
      state.productAnalytics.data = null;
      state.productAnalytics.error = null;
    },
    clearProducts: (state) => {
      state.products.data = [];
      state.products.error = null;
    },
    clearOrders: (state) => {
      state.orders.data = [];
      state.orders.error = null;
    },
    clearMonthlyRevenues: (state) => {
      state.monthlyRevenues.data = [];
      state.monthlyRevenues.error = null;
    },
    clearAllErrors: (state) => {
      state.analytics.error = null;
      state.productAnalytics.error = null;
      state.products.error = null;
      state.orders.error = null;
      state.monthlyRevenues.error = null;
    },
  },
  extraReducers: (builder) => {
    getBandAnalyticsBuilder(builder);
    getMonthlyBandRevenuesByPeriodBuilder(builder);
    getBandProductAnalyticsBuilder(builder);
    getBandProductsBuilder(builder);
    getBandOrdersBuilder(builder);
    getBandMonthlyRevenuesBuilder(builder);
  },
});

export const {
  clearAnalytics,
  clearProductAnalytics,
  clearProducts,
  clearOrders,
  clearMonthlyRevenues,
  clearAllErrors,
} = bandDashboardSlice.actions;

// Selectors
export const selectBandAnalytics = (state) => state.bandDashboard.analytics;
export const selectBandProductAnalytics = (state) =>
  state.bandDashboard.productAnalytics;
export const selectBandProducts = (state) => state.bandDashboard.products;
export const selectBandOrders = (state) => state.bandDashboard.orders;
export const selectBandMonthlyRevenues = (state) =>
  state.bandDashboard.monthlyRevenues;
export const selectMonthlyBandRevenuesByPeriod = (state) =>
  state.bandDashboard.monthlyBandRevenuesByPeriod;

export default bandDashboardSlice.reducer;
